/**
 * Composed Chart Line Series Style enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum COMPOSED_CHART_LINE_SERIES_STYLE {
	LINEAR = "linear",
	SMOOTH = "smooth",
	STEP = "step"
}

export type COMPOSED_CHART_LINE_SERIES_STYLE_string = keyof typeof COMPOSED_CHART_LINE_SERIES_STYLE;

export const COMPOSED_CHART_LINE_SERIES_STYLE_default: COMPOSED_CHART_LINE_SERIES_STYLE_string = "LINEAR";
